import { createSlice, EntityState, PayloadAction } from "@reduxjs/toolkit";

import { createEntityAdapter } from "@reduxjs/toolkit";
import { loadUrsOffer, UrsOfferRequirement } from "./ursOfferSlice";
import { RootState } from "../../app/store";

export const ursOfferRequirementsAdapter = createEntityAdapter<UrsOfferRequirement>({
    selectId: (ursOfferRequirement) => ursOfferRequirement.id,
});

interface UrsOfferRequirementsState extends EntityState<UrsOfferRequirement> {
    state: {
        ursOfferId: string | undefined
    }
}

export const initialState: UrsOfferRequirementsState = ursOfferRequirementsAdapter.getInitialState({
    state: {
        ursOfferId: undefined,
    }
});

export const ursOfferRequirementsSlice = createSlice({
    name: "ursOfferRequirements",
    initialState,
    reducers: {
        clearUrsOfferRequirementsSlice: (state) => {
            ursOfferRequirementsAdapter.removeAll(state)
            state.state = {
                ursOfferId: undefined,
            }
        },
        updateUrsOfferRequirement: (state, action: PayloadAction<UrsOfferRequirement>) => {
            const { id, ...changes } = action.payload
            ursOfferRequirementsAdapter.updateOne(state, {
                id,
                changes,
            })
        },
    },
    extraReducers: (builder) => {
        builder.addCase(loadUrsOffer.fulfilled, (state, action) => {
            state.state.ursOfferId = action.payload.id
            ursOfferRequirementsAdapter.removeAll(state)

            for (let i = 0; i < action.payload.types.length; i++) {
                const type = action.payload.types[i]
                for (let j = 0; j < type.requirements.length; j++) {
                    const requirement = type.requirements[j]
                    ursOfferRequirementsAdapter.addOne(state, requirement)
                    for (let k = 0; k < requirement.childRequirements.length; k++) {
                        const childRequirement = requirement.childRequirements[k]
                        ursOfferRequirementsAdapter.addOne(state, childRequirement)
                    }
                }
            }
        })
        builder.addCase(loadUrsOffer.rejected, (state, action) => {
            state.state.ursOfferId = undefined
        })
        builder.addCase(loadUrsOffer.pending, (state, action) => {
            state.state.ursOfferId = undefined
        })
    }
});

export const {
    selectAll: selectAllUrsOfferRequirements,
    selectById: selectUrsOfferRequirementById,
    selectIds: selectUrsOfferRequirementIds,
    selectEntities: selectUrsOfferRequirementEntities,
    selectTotal: selectTotalUrsOfferRequirements,
} = ursOfferRequirementsAdapter.getSelectors()

export const selectUrsOfferRequirements = (state: RootState) => state.ursOfferRequirements

export const {
    updateUrsOfferRequirement,
} = ursOfferRequirementsSlice.actions

export default ursOfferRequirementsSlice.reducer;